<template>
  <div class="sms-code">
    <label :for="`code-${uuid}`">
      <ul class="sms-code__container">
        <div
          class="sms-code__caret"
          :style="caretStyle"
        />
        <li
          v-for="(item, index) in length"
          :key="index"
          class="sms-code-field"
        >
          <i class="sms-code-field__char">{{ value[index] || placeholder }}</i>
        </li>
      </ul>
    </label>
    <input
      :id="`code-${uuid}`"
      ref="input"
      :value="value"
      class="sms-code__input-code"
      :name="`code-${uuid}`"
      autocomplete="one-time-code"
      type="number"
      pattern="[0-9]*"
      :maxlength="length"
      autocorrect="off"
      autocapitalize="off"
      @wheel.prevent="wheel()"
      @mouse-wheel.prevent="wheel()"
      @input="handleInput($event)"
      @keyup="handleKey($event)"
      @focus.stop="$emit('focus')"
      @blur="$emit('blur')"
    >
  </div>
</template>

<script>

export default {
  name: 'SmsCode',
  props: {
    value: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 4,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value', 'focus', 'blur'],
  data () {
    return {
      // valueLocal: '',
      mount: false,
    }
  },
  computed: {
    uuid () {
      return Math.random().toString(36).substring(3, 8)
    },
    caretStyle () {
      if (this.mount) {
        if (this.value.length >= 0 && this.value.length < this.length) {
          const fields = this.$el.querySelectorAll('.sms-code-field')
          const offsetLeft = fields[this.value.length].offsetLeft

          return {
            opacity: 1,
            transform: `translateX(${offsetLeft}px)`,
          }
        }
        if (this.value.length >= this.length) {
          return {
            opacity: 0,
            transform: 'translateX(1000px)',
          }
        }
        // return {
        //   opacity: 1,
        //   transform: `translateX(${this.$refs.field[0].offsetLeft}px)`
        // }
      }
      return {}
    },
  },
  mounted () {
    this.mount = true
  },
  methods: {
    hideKeyboard () {
      document.activeElement.blur() // ios
      this.$refs.input.blur() // android
    },
    handleInput (e) {
      if (e.target.value.length <= this.length) {
        this.$emit('update:value', e.target.value)
      }
    },
    handleKey (e) {
      // if (e.target.value.length >= this.length) {
      //   this.hideKeyboard()
      // }
    },
    focus () {
      this.$refs.input.focus()
    },
    wheel () {
      this.$refs.input.blur()
      setTimeout(() => {
        this.$refs.input.focus()
      }, 10)
    },
  },
}
</script>

<style lang="scss">
  .sms-code {
    position: relative;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &__container {
      margin: 0;
      position: relative;
      padding: 0;
      display: flex;
      border-radius: .16rem;
      background: #F0F0F0;
      width: fit-content;
      padding: .04rem .14rem;
    }
    &__input-code {
      position: absolute;
      z-index: 10;
      // visibility: hidden;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      // left: -9999px;
      // top: -9999px;
    }
    &__caret {
      position: absolute;
      left: 0;
      top: calc(100% + .06rem);
      width: .48rem;
      height: 2px;
      border-radius: 2px;
      background: map-get($colors, 'default');
      opacity: 0;
      transition: opacity transform;
      transition-duration: 300ms;
    }
  }

  .sms-code-field {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: .48rem;
    width: .48rem;
    border: 1px solid transparent;
    &:not(:last-child) {
      margin-right: .08rem;
    }
    &__char {
      font-style: normal;
      font-weight: 300;
      font-size: 32px;
      line-height: 38px;
      text-align: center;
      letter-spacing: 1.32719px;
    }
  }

</style>
